<template>
  <div class="mt-4 mb-4">
    <b-card border-variant="primary" header-text-variant="primary" v-for="(codevedor, index) in codevedores"
      v-bind:key="codevedor.id_codevedor">
      <template v-slot:header>
        {{especie === 'CH' ? 'Informações do Co-emitente' : 'Informações do Devedor'}} [{{+ + index + 1 }}]
        <span v-b-popover.hover.top="'Pessoa Física ou Jurídica responsável pelo pagamento do título ou documento de dívida.'" title="Devedor" class="infolet">i</span>
        <b-button variant="danger" class="float-right" @click="removerCodevedor(codevedor.id_codevedor)"
                  v-b-tooltip.hover="{ title: especie === 'CH' ? 'Remover Co-emitente' : 'Remover Codevedor' }">
          <span class="mr-3">Excluir</span>
          <font-awesome-icon icon="trash" />
        </b-button>
      </template>
      <b-card-text>
        <b-row>
          <b-col cols="12" md="4" lg="4">
            <label for="documento_devedor">CPF/CNPJ:</label>
            <b-input v-model="codevedor.nm_nr_documento" placeholder="Documento" maxlength="18"
              :state="codevedor.state.documento" :formatter="formataDocumento" required
              @input="atualizaDadosendereco(codevedor.id_codevedor)"
              @blur="validarDocumento('documento_devedor', $event, codevedor.id_codevedor);">
            </b-input>
            <b-form-invalid-feedback :state="codevedor.state.documento">Infome um documento válido.</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="4" lg="8">
            <label for="nome_solicitante">Nome:</label>
            <b-input v-model="codevedor.nm_nome" maxlength="45" placeholder="Nome" :state="codevedor.state.nome"
              id="outorgante_nome" required @input="atualizaDadosendereco(codevedor.id_codevedor)"></b-input>
            <b-form-invalid-feedback :state="codevedor.state.nome">Infome o nome.</b-form-invalid-feedback>
          </b-col>
        </b-row>
        <b-row class="mt-2">

          <b-col cols="12" md="8">
            <label for="email_sacador">Email:</label>
            <b-input v-model="codevedor.email_devedor" placeholder="email" maxlength="50" required>
            </b-input>
            <b-form-invalid-feedback :state="codevedor.state.email_devedor">E-mail inválido.</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="4">
            <label for="nome_solicitante">Contato:</label>
            <b-input v-model="codevedor.celular_devedor" :formatter="formataTelefone" maxlength="15" placeholder="(XX) 9123-4567"></b-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <hr />
            <h4 class="text-primary mt-2">Endereço:</h4>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="3" lg="3">
            <label for="outorgante_cep">CEP:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_nr_cep_devedor"
              @blur="BuscarCep(codevedor.id_codevedor)" maxlength="9" type="text" placeholder="_____-___"
              :state="codevedor.state.cep" :formatter="formataCEP" id="endereco_sacador" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.cep">CEP inválido.</b-form-invalid-feedback>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" md="6">
            <label for="outorgante_logradouro">Logradouro:</label>
            <b-input v-model="codevedor.endereco_devedor.logradouro"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="30" type="text" placeholder="Logradouro"
              :state="codevedor.state.endereco_logradouro" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.endereco_logradouro">Logradouro inválido.</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_numero">Número:</label>
            <b-input v-model="codevedor.endereco_devedor.numero"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="5" type="text" placeholder="Número"
              :state="codevedor.state.endereco_numero" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.endereco_numero">Número do endereço inválido.</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_complemento">Complemento: <i>(Opcional)</i></label>
            <b-input v-model="codevedor.endereco_devedor.complemento"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="10" type="text" placeholder="Complemento"></b-input>
          </b-col>
          <!-- <b-col cols="12" md="6">
            <label for="outorgante_endereco">Endereço:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_endereco_devedor"
              @input="atualizaDadosendereco(codevedor.id_codevedor)" maxlength="45" type="text" placeholder="Endereço"
              :state="codevedor.state.endereco" required></b-input>
            <b-form-invalid-feedback :state="codevedor.state.endereco">
              Endereço inválido.
            </b-form-invalid-feedback>
          </b-col> -->
          <b-col cols="12" md="6">
            <label for="outorgante_bairro">Bairro:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_bairro_devedor" maxlength="20" type="text" placeholder="Bairro"
              :state="codevedor.state.bairro" id="outorgante_bairro" required
              @input="atualizaDadosendereco(codevedor.id_codevedor)"></b-input>
            <b-form-invalid-feedback :state="codevedor.state.bairro">Informe o Bairro.</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_cidade">Cidade:</label>
            <b-input v-model="codevedor.endereco_devedor.nm_cidade_devedor" maxlength="20" type="text" placeholder="Cidade"
              :state="codevedor.state.cidade" id="outorgante_cidade" required
              @input="atualizaDadosendereco(codevedor.id_codevedor)"></b-input>
            <b-form-invalid-feedback :state="codevedor.state.cidade">Informe a Cidade.</b-form-invalid-feedback>
          </b-col>
          <b-col cols="12" md="6">
            <label for="outorgante_uf">UF:</label>
            <v-select v-model="codevedor.endereco_devedor.uf_selecionada" :options="estados" :state="codevedor.state.uf" :class="{'is-invalid': codevedor.state.uf === false}"
              @change="atualizaDadosendereco(codevedor.id_codevedor)" :clearable="false" required>
              <template #no-options> Nenhuma opção disponível...</template>
            </v-select>
            <b-form-invalid-feedback :state="codevedor.state.uf">Informe a UF.</b-form-invalid-feedback>
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
  </div>
</template>
<script>
import axios from "axios";
import API from "../../services/api";
import {formataCEP, formataDocumento, formataTelefone} from "@/utils/formatters/Formatter"
import {isDocumentoCPF, limpaDocumento, validateDocumento} from "@/utils/validators/Documento";

export default {
  props: ['codevedores', 'estados', 'docDevedor', 'docCedente', 'docSacador', 'especie'],
  data() {
    return {
      emailValidationRegex: /^[a-zA-Z0-9]+([._-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)+$/g,
      id_codevedor: "",
      indexCodevedor: null,
      dadosCep: {
        nm_nr_cep_devedor: "",
        nm_endereco_devedor: "",
        logradouro:'',
        numero:'',
        complemento:'',
        uf_selecionada: {},
        cd_uf: "",
        sg_uf_devedor: "",
        nm_cidade_devedor: "",
        nm_bairro_devedor: ""
      },
    }
  },
  methods: {
    formataDocumento,
    formataTelefone,
    formataCEP,
    validateEmail(event, id_codevedor) {
      let email = event.target.value
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor === id_codevedor);
      this.$props.codevedores[indexCodevedor].state.email_devedor  = (email != null && email != '') ? this.emailValidationRegex.test(email) : true;
    },
    validarDocumento(validation, event, id_codevedor) {
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor === id_codevedor);
      if(!event) return this.$props.codevedores[indexCodevedor].state[validation] = true;
      else {
        var documento = limpaDocumento(event.target.value);
        let isInvalid = !validateDocumento(documento);
        this.$props.codevedores[indexCodevedor].state[validation] = isInvalid;
        if(isInvalid) return false
        this.$emit('updateBloqueio9430', isDocumentoCPF(documento));
      }
      this.validarDuplicidadeDocumento(id_codevedor)
      this.popularPessoa(indexCodevedor);
    },
    validarDuplicidadeDocumento(id_codevedor){
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor);
      //validar não permitir que o Documento do Devedor seja igual ao Documento do Sacador ou do Cedente.
      let docCodevedor = this.$props.codevedores[indexCodevedor].nm_nr_documento;
      let codevedorDuplicado = this.$props.codevedores.filter(d => d.nm_nr_documento === docCodevedor && d.id_codevedor !== id_codevedor);
      if (codevedorDuplicado.length > 0) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Devedor/Codevedor");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      } else if ((this.docSacador !== '') && (this.docSacador === docCodevedor)) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      } else if ((this.docCedente !== '') && (this.docCedente === docCodevedor)) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Sacador ou Cedente");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      } else if ((this.docDevedor !== '') && (this.docDevedor === docCodevedor)) {
        this.$emit('errorCodevedor', "Documento do Devedor não poder ser igual ao Documento do Devedor/Codevedor");
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nr_documento", "");
      }
    },
    popularPessoa(indexCodevedor) {
      if(isDocumentoCPF(this.$props.codevedores[indexCodevedor].nm_nr_documento)) this.consultaDocumento(indexCodevedor);
      else this.consultaCnpj(indexCodevedor);
    },
    consultaDocumento(indexCodevedor) {
      const token = localStorage.getItem("jwtToken");
      API.post('protesto/consultaDevedor', {
        token: token,
        documento: this.$props.codevedores[indexCodevedor].nm_nr_documento
      }).then((res) => {
        let cep = res.data.dados.nm_nr_cep_devedor.substring(0, 5) + '-' + res.data.dados.nm_nr_cep_devedor.substring(5, 8);
        let uf = this.estados.find((d) => d.text == res.data.dados.sg_uf_devedor);
        this.$set(this.$props.codevedores[indexCodevedor], "nm_nome", res.data.dados.nm_devedor);
        this.$set(this.$props.codevedores[indexCodevedor], "email_devedor", res.data.dados.nm_email_devedor);
        this.$set(this.$props.codevedores[indexCodevedor], "celular_devedor", res.data.dados.nm_nr_celular_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_endereco_devedor", res.data.dados.nm_endereco_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_cidade_devedor", res.data.dados.nm_cidade_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_nr_cep_devedor", cep);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_bairro_devedor", res.data.dados.nm_bairro_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "uf", res.data.dados.sg_uf_devedor);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "uf_selecionada", uf);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "cd_uf", uf.value);
        this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "sg_uf_devedor", res.data.dados.sg_uf_devedor);
        this.$set(this.$props.codevedores[indexCodevedor], "devedor_cep", cep);
        this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores });
      })
    },
    consultaCnpj(indexCodevedor) {
      const token = localStorage.getItem("jwtToken");
      const codevedor = this.$props.codevedores[indexCodevedor];

      console.log(codevedor.nm_nr_documento)
      // Verificar se o objeto codevedor é válido antes de continuar
      if (codevedor && codevedor.nm_nr_documento) {
        API.post('protesto/empresa', {
          token: token,
          documento: limpaDocumento(codevedor.nm_nr_documento)
        }).then((res) => {
          if (res.data.status === true) {
            const servico = res.data.servico;
            let cep = servico.cep.substring(0, 5) + '-' + servico.cep.substring(5, 8);
            let uf = this.estados.find((d) => d.text === servico.estado);
            // Preencher os campos do objeto codevedores[indexCodevedor] com os dados retornados pela API
            this.$set(codevedor, "nm_nome", servico.nome);
            this.$set(codevedor, "email_devedor", servico.email);
            this.$set(codevedor, "celular_devedor", servico.contato);
            this.$set(codevedor.endereco_devedor, "nm_endereco_devedor", servico.endereco);
            this.$set(codevedor.endereco_devedor, "nm_cidade_devedor", servico.cidade);
            this.$set(codevedor.endereco_devedor, "nm_nr_cep_devedor", cep);
            this.$set(codevedor.endereco_devedor, "nm_bairro_devedor", servico.bairro);
            this.$set(codevedor.endereco_devedor, "uf", servico.estado);
            this.$set(codevedor.endereco_devedor, "uf_selecionada", uf);
            this.$set(codevedor.endereco_devedor, "cd_uf", uf.value);
            this.$set(codevedor.endereco_devedor, "sg_uf_devedor", servico.estado);
            this.$set(codevedor, "devedor_cep", cep);

            // Emitir evento para informar o componente pai sobre a atualização dos dados dos co-devedores
            this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores });
          }
        }).catch((error) => {
          console.error('Erro ao consultar CNPJ:', error);
        });
      } else {
        console.error('Objeto codevedor inválido ou não possui a propriedade nm_nr_documento');
      }
    },
    removerCodevedor: function (codevedor) {
      console.log(codevedor)
      let codevedores = this.$props.codevedores;
      let indexCodevedor = codevedores.findIndex(d => d.id_codevedor === codevedor)
      if (indexCodevedor > -1) codevedores.splice(indexCodevedor, 1)
      this.$emit('removecodevedor', true)
    },
    dadosCodevedor: function (id_codevedor) {
      return this.$props.codevedores.filter(d => d.id_codevedor === id_codevedor);
    },
    BuscarCep: function (idCodevedor) {
      console.log(idCodevedor)
      if(idCodevedor == null) return;
      var codevedor = this.dadosCodevedor(idCodevedor);
      var cep = codevedor[0].endereco_devedor.nm_nr_cep_devedor;
      if(cep.length !== 9 || cep === this.dadosCep.nm_nr_cep_devedor) return;
      var cepl = cep.replace("-", "");
      var self = this;
      try {
        axios
          .get(`https://viacep.com.br/ws/${cepl}/json/`)
          .then((resp) => {
            if (resp.data.erro) {
              this.limparCamposEndereco();
              const token = localStorage.getItem("jwtToken");
              API.get('cran/cep', {
                params: {
                  cep: cepl
                },
                token: token
              }).then((resCran) => {
                let uf = self.estados.find((d) => d.text == resCran.data.uf);
                self.$set(self.dadosCep, "cd_uf", uf.value);
                self.$set(self.dadosCep, "sg_uf_devedor", uf.text);
                self.$set(self.dadosCep, "uf_selecionada", uf);
                self.$set(self.dadosCep, "nm_cidade_devedor", resCran.data.municipio.substr(0, 20))
                self.$set(self.dadosCep, "nm_nr_cep_devedor", cep)
              }).catch((err) => {
                this.limparCamposEndereco();
                this.$bvToast.toast(`Erro ao inesperado buscar CEP`, {
                  title: 'Erro ao buscar dados do CEP!',
                  variant: 'danger',
                  toaster: 'b-toaster-bottom-center',
                  autoHideDelay: 5000,
                  solid: true
                });
              });
            } else {
              let uf = self.estados.find((d) => d.text == resp.data.uf);
              self.$set(self.dadosCep, "nm_nr_cep_devedor", cep)
              self.$set(self.dadosCep, "nm_endereco_devedor", (resp.data.logradouro + " " + resp.data.complemento).substr(0, 45))
              self.$set(self.dadosCep, "logradouro", resp.data.logradouro.substr(0, 30))
              self.$set(self.dadosCep, "nm_cidade_devedor", resp.data.localidade.substr(0, 20))
              self.$set(self.dadosCep, "nm_bairro_devedor", resp.data.bairro.substr(0, 20))
              self.$set(self.dadosCep, "uf_selecionada", uf);
              self.$set(self.dadosCep, "cd_uf", uf.value);
              self.$set(self.dadosCep, "sg_uf_devedor", uf.text);
            }
          })
      } catch (error) {
        this.limparCamposEndereco();
        this.$bvToast.toast(`Erro ao inesperado buscar CEP`, {
          title: 'Erro ao buscar dados do CEP!',
          variant: 'danger',
          toaster: 'b-toaster-bottom-center',
          autoHideDelay: 5000,
          solid: true
        })
      }
      this.$emit('populaEnderecoCodevedor', { id_codevedor: idCodevedor, dados: self.dadosCep });
      this.limparCamposEndereco();
    },
    limparCamposEndereco(){
      this.$set(this.dadosCep, "nm_nr_cep_devedor", "");
      this.$set(this.dadosCep, "nm_endereco_devedor", "");
      this.$set(this.dadosCep, "nm_bairro_devedor", "");
      this.$set(this.dadosCep, "nm_cidade_devedor", "");
      this.$set(this.dadosCep, "logradouro", "");
      this.$set(this.dadosCep, "complemento", "");
      this.$set(this.dadosCep, "numero", "");
      this.$set(this.dadosCep, "uf_selecionada", {});
      this.$set(this.dadosCep, "cd_uf", "");
      this.$set(this.dadosCep, "sg_uf_devedor", "");
    },
    atualizaDadosendereco(id_codevedor) {
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor)
      let enderecoCodevedor = this.$props.codevedores[indexCodevedor].endereco_devedor;
      this.$props.codevedores[indexCodevedor].endereco_devedor.nm_endereco_devedor = 
                                                              enderecoCodevedor.logradouro + ", "
                                                              + enderecoCodevedor.numero + 
                                                              (enderecoCodevedor.complemento ? " - " + enderecoCodevedor.complemento: "");

      let cd_uf = this.$props.codevedores[indexCodevedor].endereco_devedor.cd_uf
      let dadosUfSelecionada = this.estados.find((d) => d.value == cd_uf);
      if (dadosUfSelecionada != undefined) this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "sg_uf_devedor", dadosUfSelecionada.text);

      this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores })
    },
    populaendereco(id_codevedor, endereco) {
      console.log(endereco)
      let indexCodevedor = this.$props.codevedores.findIndex(d => d.id_codevedor == id_codevedor)

      this.indexCodevedor = indexCodevedor;
      this.id_codevedor = id_codevedor
      console.log(this.$props.codevedores[indexCodevedor].endereco_devedor.logradouro)
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_bairro_devedor",    endereco.nm_bairro_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_endereco_devedor",  endereco.nm_endereco_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "logradouro",           endereco.logradouro);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "numero",               endereco.numero);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "complemento",          endereco.complemento);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "nm_cidade_devedor",    endereco.nm_cidade_devedor);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "uf_selecionada",       endereco.uf_selecionada);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "cd_uf",                endereco.cd_uf);
      this.$set(this.$props.codevedores[indexCodevedor].endereco_devedor, "sg_uf_devedor",        endereco.sg_uf_devedor);
      this.$props.codevedores[indexCodevedor].endereco_devedor.logradouro = endereco.logradouro;
      console.log(this.$props.codevedores[indexCodevedor].endereco_devedor.logradouro)
      this.$emit('atualizaCodevedores', { codevedores: this.$props.codevedores })

      this.$set(this.dadosCep, "nm_bairro_devedor", '');
      this.$set(this.dadosCep, "nm_cidade_devedor", '');
      this.$set(this.dadosCep, "nm_endereco_devedor", '');
      this.$set(this.dadosCep, "logradouro", '');
      this.$set(this.dadosCep, "numero", '');
      this.$set(this.dadosCep, "complemento", '');
      this.$set(this.dadosCep, "uf_selecionada", {});
      this.$set(this.dadosCep, "cd_uf", '');
      this.$set(this.dadosCep, "sg_uf_devedor", '');

    },
  },
  // watch: {
  //   codevedores: {
  //     deep: true,
  //     handler(dadosCodevedor) {
  //       let enderecoDevedor = this.indexCodevedor != null ? dadosCodevedor[this.indexCodevedor].endereco_devedor.nm_nr_cep_devedor : ''
  //       if (this.indexCodevedor != null && dadosCodevedor[this.indexCodevedor].endereco_devedor.nm_nr_cep_devedor.length == 9 && (enderecoDevedor != this.dadosCep.nm_nr_cep_devedor)) {
  //         this.BuscarCep(dadosCodevedor[this.indexCodevedor].endereco_devedor.nm_nr_cep_devedor);
  //       }
  //
  //     }
  //
  //   },
  // },
  created() {
  },
}
</script>
<style scoped>

::v-deep .vs--disabled .vs__search{
  background: #ffffff 0% 0% no-repeat padding-box;
}
::v-deep .vs__dropdown-toggle {
  border: 2px solid var(--light-gray-color);
  background: #ffffff 0% 0% no-repeat padding-box;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 8px;
  height: 49px;
  vertical-align: middle;
  color: var(--secondary-color);
  padding: 0 12px;
}
::v-deep .vs__dropdown-toggle .vs__clear {
  margin-bottom: 5px;
  margin-right: 18px;
}
::v-deep .vs--open .vs__dropdown-toggle{
  border-radius: 8px 8px 0px 0px;
  border-left: 0.2rem solid var(--primary-color);
  border-right: 0.2rem solid var(--primary-color);
  border-top: 0.2rem solid var(--primary-color);
}
::v-deep .vs--open .vs__selected{
  position: unset !important;
}
::v-deep .vs__dropdown-option {
  margin: 0.15rem;
  border-radius: 8px;
}

::v-deep .vs__dropdown-option--selected{
  background: color-mix(in srgb, var(--primary-color) 20%, transparent);
}
::v-deep .vs__dropdown-option--highlight{
  background: color-mix(in srgb, var(--secondary-color) 10%, transparent);
  color: var(--secondary-color);
}
::v-deep .vs__dropdown-menu {
  background: #ffffff 0% 0% no-repeat padding-box;
  font: normal normal 300 20px/20px 'Kanit', sans-serif;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 0px 0px 8px 8px;
  border: none;
  vertical-align: middle;
  color: var(--secondary-color);
  box-shadow:0px 20px 52px -27px rgba(0,0,0,0.15);
}
::v-deep .vs--open .vs__dropdown-menu {
  border-left: 0.2rem solid var(--primary-color);
  border-right: 0.2rem solid var(--primary-color);
  border-bottom: 0.2rem solid var(--primary-color);
}
.form-control:focus,
.card-text select.custom-select:focus {
  box-shadow: 0 0 0 0.2rem var(--primary-color);
}

.card-text input.form-control::placeholder {
  color: #A8A8A8;
}
.card-header {
  font: normal normal 200 20px/41px 'Kanit', sans-serif;
  letter-spacing: -1%;
  padding: 13px 22px;
  color: var(--secondary-color) !important;
  background-color: transparent;
  border:none;
}

.card-body {
  border: none;
  border-radius: 22px;
  box-shadow: 0px 0px 15px 0 #D1DBE260;
}

.card-header .infolet {
  background: var(--primary-color) 0% 0% no-repeat padding-box;
  border-radius: 100%;
  font: normal normal 400 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: #FFFFFF;
  padding: 0px 10px 0px 9.5px;
  left: 5px !important;
  position: relative;
  top: -1.5px;
}


.card-text label {
  font: normal normal 200 16px/20px 'Kanit', sans-serif;
  letter-spacing: -1%;
  color: var(--secondary-color);
  margin-bottom: 12px;
  margin-left: 12px;
}

.card-text label i {
  font: italic normal 200 16px/20px 'Kanit', sans-serif;
}

#painel .card-text input.form-control:not(.is-invalid),
#painel .card-text select.custom-select:not(.is-invalid),
::v-deep .vs--searchable:not(.is-invalid) .vs__dropdown-toggle {
  border-color: var(--light-gray-color);
}
.card-text input.form-control,
.card-text select.custom-select {
  border-width: 2px;
  text-align: left;
  letter-spacing: -1%;
  border-radius: 8px;
  height: 49px;
  vertical-align: middle;
  color:var(--secondary-color);
  padding: 0 12px;
}

::v-deep .vs--searchable.is-invalid .vs__dropdown-toggle{
  border-color: #dc3545;
}


.card-text select.custom-select {
  cursor: pointer;
}


.btn.btn-danger{
  width: fit-content;
  height: 49px;
  border: none;
  border-radius: 40px;
  text-align: center;
  font: normal normal 300 20px/15px 'Kanit', sans-serif;
  letter-spacing: -1%;
  padding: 0 30px;
}

h4{
  text-align: left;
  font: normal normal 200 20px/30px 'Kanit', sans-serif;
  letter-spacing: 0px;
  color: var(--secondary-color);
  margin: 0;
  margin-bottom: 1rem;
}
hr{
  margin-top: 28px;
  margin-bottom: 17px;
}

</style>